// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon} from '@wandb/weave/components/Icon';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import * as React from 'react';
import {useEffect} from 'react';
import {twMerge} from 'tailwind-merge';

import {LoadableView} from '../../state/views/types';
import {UNAVAILBALE_WORKSPACES_ERROR} from '../../state/workspaces/namedWorkspaceUrls';
import {WorkspaceError as WorkspaceErrorType} from '../../state/workspaces/types';
import {useTrackWorkspaceError} from './utils';
// eslint-disable-next-line import/no-cycle -- please fix if you can
import {WorkspaceEmptyContent} from './WorkspaceEmptyContent';

export type WorkspaceErrorContentProps = {
  error?: WorkspaceErrorType;
  viewType: LoadableView['type'] | undefined;
};
export const WorkspaceErrorContent = (props: WorkspaceErrorContentProps) => {
  if (props.error?.userTitle === UNAVAILBALE_WORKSPACES_ERROR.userTitle) {
    return <WorkspaceEmptyContent {...props} />;
  }

  return <WorkspaceGenericErrorContent {...props} />;
};

const WorkspaceGenericErrorContent = ({
  error,
  viewType,
}: WorkspaceErrorContentProps) => {
  const trackWorkspaceError = useTrackWorkspaceError({
    action: 'View',
    errorType: 'Generic',
    viewType,
  });

  useEffect(() => {
    trackWorkspaceError(error);
  }, [error, trackWorkspaceError]);

  return (
    <WorkspaceError
      title={error?.userTitle ?? 'Something went wrong'}
      header={
        <div
          className={twMerge(
            'mb-16 h-[80px] w-[80px] shrink-0 rounded-full',
            'bg-moon-550/[.1] text-moon-550',
            'flex items-center justify-center'
          )}>
          <Icon name="warning" width={34} height={34} />
        </div>
      }>
      <div className="text-wrap mt-4 w-[600px] text-center text-lg leading-[140%]">
        <p>
          {error?.userMessage
            ? error?.userMessage
            : 'An unexpected error occurred.'}
        </p>
        <p>
          Please contact{' '}
          <a
            className="font-semibold hover:text-teal-500"
            href="mailto:support@wandb.com"
            rel="noopener noreferrer">
            support@wandb.com
          </a>{' '}
          for help.
        </p>
      </div>
    </WorkspaceError>
  );
};

export const WorkspaceError = ({
  children,
  title,
  header,
}: {
  title: string;
  header?: React.ReactNode;
  children?: React.ReactNode;
}) => {
  return (
    <Tailwind>
      <div
        className={twMerge(
          'flex flex-col items-center justify-center',
          'h-[calc(100vh-60px)] w-full pb-[60px]'
        )}>
        {header}
        <h1 className="text-2xl font-semibold leading-[32px]">{title}</h1>
        {children}
      </div>
    </Tailwind>
  );
};
